<template>
	<div class="inner-page enquiry-form">
		<AppHead title="Default Enquiry Forms" />

		<PageHeader 
      title="Default Enquiry Forms"
      desc="Change the default enquiry forms which are given to users who are not part of a distributor when they create a new case."
      :hasButton="false"
      :showHelper="true"
      helpTitle="This is where you change the default enquiry form"
      helpDesc="All enquiry forms in this list will be supplied to new cases that are not part of a distributor, or where the distributor doesn't have enquiry forms set. Please give each form a nice name, otherwise the filename will be shown"
      />

    <EnquiryFormUploadControls 
      @done="refreshFiles"
      />

    <TableDocuments
      title="Available Default Enquiry Forms"
      desc="All of these enquiry forms will be shown to a user in the Enquiry Form submission phase whe nthey are not part of a distributor or if their distributor doesn't have any enquiry forms set."
      noDocsMessage="There are no enquiry forms available"
      :files="enquiryForms"
      :canDelete="true"
      :showProcessing="['admin', 'team_admin'].includes($page.props.user.user_type)"
      />

    
	</div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import TableDocuments from "@/Components/TableDocuments"
import EnquiryFormUploadControls from "@/Components/Admin/EnquiryFormUploadControls"

export default {
	components: {
		AppLayout,
    AppHead,
    PageHeader,
    TableDocuments,
    EnquiryFormUploadControls
	},
  props: {
    enquiryForms: Array
  },
  mounted(){
    
  },
  methods: {
    refreshFiles(){
      this.$inertia.reload()
    }
  },
	layout: AppLayout
};
</script>

<style lang="sass">

// .enquiry-form

</style>